import { domToReact, htmlToDOM } from "html-react-parser";
import { sanitizeHtmlTree } from "@/helpers/sanitizeHtmlTree";

/**
 * Le HTML écrit par un membre (présentation du profil, retour d'un
 * correcteur, commentaire d'un rendu), nettoyé puis rendu en éléments React.
 *
 * À utiliser partout où l'on écrivait `dangerouslySetInnerHTML` sur un texte
 * qui ne vient pas de l'équipe. Ne renvoie jamais de HTML brut : au pire,
 * rien. Pour un contenu avec blocs de code colorés, passer par
 * helpers/transformHtml.js, qui applique le même nettoyage.
 *
 * Fichier à part pour ne pas tirer Shiki dans les pages qui n'affichent
 * qu'une présentation de trois lignes.
 */
export function renderMemberHtml(content) {
    if (typeof content !== "string" || !content) return null;
    try {
        return domToReact(
            sanitizeHtmlTree(
                htmlToDOM(content, { lowerCaseAttributeNames: false }),
            ),
        );
    } catch (error) {
        console.error("Erreur lors du nettoyage du contenu :", error);
        return null;
    }
}
